
import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { speechEventTypes, targetAudienceTypes, speechObjectiveTypes } from "@/constants/documentTypes"

interface SpeechFieldsProps {
  eventType?: string
  targetAudience?: string
  speechObjective?: string
  onChange: (field: string, value: string) => void
}

export function SpeechFields({ eventType, targetAudience, speechObjective, onChange }: SpeechFieldsProps) {
  return (
    <>
      <div className="space-y-2">
        <Label className="text-sm font-medium text-gray-700 after:content-['*'] after:ml-0.5 after:text-red-500">
          Tipo de Evento
        </Label>
        <Select
          value={eventType}
          onValueChange={(value) => onChange("eventType", value)}
          required
        >
          <SelectTrigger className="w-full border-gray-200 focus:ring-primary/20">
            <SelectValue placeholder="Selecione o tipo de evento" />
          </SelectTrigger>
          <SelectContent className="max-h-[200px] overflow-y-auto">
            {speechEventTypes.map((type) => (
              <SelectItem key={type} value={type}>
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label className="text-sm font-medium text-gray-700 after:content-['*'] after:ml-0.5 after:text-red-500">
          Público Alvo
        </Label>
        <Select
          value={targetAudience}
          onValueChange={(value) => onChange("targetAudience", value)}
          required
        >
          <SelectTrigger className="w-full border-gray-200 focus:ring-primary/20">
            <SelectValue placeholder="Selecione o público alvo" />
          </SelectTrigger>
          <SelectContent className="max-h-[200px] overflow-y-auto">
            {targetAudienceTypes.map((type) => (
              <SelectItem key={type} value={type}>
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label className="text-sm font-medium text-gray-700 after:content-['*'] after:ml-0.5 after:text-red-500">
          Objetivo do Discurso
        </Label>
        <Select
          value={speechObjective}
          onValueChange={(value) => onChange("speechObjective", value)}
          required
        >
          <SelectTrigger className="w-full border-gray-200 focus:ring-primary/20">
            <SelectValue placeholder="Selecione o objetivo do discurso" />
          </SelectTrigger>
          <SelectContent className="max-h-[200px] overflow-y-auto">
            {speechObjectiveTypes.map((type) => (
              <SelectItem key={type} value={type}>
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </>
  )
}
